// import React, { useEffect } from 'react'
// import { useParams, Link } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import { format, parseISO } from 'date-fns';

// import { getContract } from "../../features/contractSlice"
// import { canAddContractRoles } from '../../utils/Constants';
// import { formatAddress, determineAccess } from '../../utils/Helper';

// import Spinner from "../Layout/Spinner"
// import NotAuthorized from '../Others/NotAuthorized';

// const ContractDetails = () => {

//     const { id } = useParams()
//     const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
//     const { contract, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

//     const dispatch = useDispatch()

//     useEffect(() => {
//         const contract_id = id
//         dispatch(getContract({ contract_id, idToken }))
//     }, [dispatch, id, idToken])

//     if (loading) return <Spinner />

//     // Then check if contract exists before determining access
//     if (!contract || Object.keys(contract).length === 0) {
//         return <Spinner />
//     }

//     const access = determineAccess(role, email, agentEmail, contract)
//     if (!access) return <NotAuthorized />


//     return (
//         <div>
//             {Object.keys(contract).length > 0 && (
//                 <div className='min-h-screen px-4 py-6'>
//                     <div className='container-xl lg:container m-auto'>

//                         {canAddContractRoles.includes(role) && (
//                             <div className='grid grid-cols-2 md:grid-cols-4 gap-2'>
//                                 <button className='w-[150px] h-[36px] bg-gray-500 hover:bg-gray-600 text-white rounded-lg text-center text-sm'>
//                                     <Link to={"/"}>Dashboard</Link>
//                                 </button>
//                                 <button className='w-[150px] h-[36px] bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-center text-sm mb-2' >
//                                     <Link to={`/edit-contract-steps/${contract.contract_id}`}>Edit Workflow</Link>
//                                 </button>
//                                 <button className='w-[150px] h-[36px] bg-cyan-500 hover:bg-cyan-600 text-white rounded-lg text-center text-sm mb-2' >
//                                     <Link to={`/edit-contract-info/${contract.contract_id}`}>Edit Information</Link>
//                                 </button>
//                                 <button className='w-[150px] h-[36px] bg-red-500 hover:bg-red-600 text-white rounded-lg text-center text-sm mb-2' >
//                                     <Link to={`/archive-contract/${contract.contract_id}`}>Delete Contract</Link>
//                                 </button>
//                             </div>
//                         )}

//                         <div className="bg-white px-6 py-8">
//                             <div className='text-xl text-center font-semibold uppercase'>Contract Details</div>
//                             <div className='text-center font-bold text-xl mb-5'>
//                                 {formatAddress(contract.address, contract.apartment, contract.city, contract.state, contract.zipcode)}
//                             </div>
//                             <div className='text-center'>
//                                 Contract Acceptance Date: {format(parseISO(contract.contract_acceptance_date), 'MM/dd/yyyy')}
//                             </div>
//                             <div className='text-center'>
//                                 Contract Status: <span className='font-bold'>{contract.contract_status}</span>
//                             </div>
//                             {contract.sale_price && (
//                                 <div className='text-center'>
//                                     Contract Sales Price: <span className='font-bold'>${new Intl.NumberFormat('en-US').format(contract.sale_price)}</span>
//                                 </div>
//                             )}

//                             <div className='grid grid-cols-1 md:grid-cols-2 gap-4 '>
//                                 {contract.agent_name && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Agent</div>
//                                         <div className='text-center'>
//                                             <div>{contract.agent_name}</div>
//                                             <div>{contract.agent_email}</div>
//                                             <div>{contract.agent_phone}</div>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {contract.buyer_name && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Buyer</div>
//                                         <div className='text-center'>
//                                             <div>{contract.buyer_name}</div>
//                                             <div>{contract.buyer_email}</div>
//                                             <div>{contract.buyer_phone}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {contract.co_buyer_name && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Co-Buyer</div>
//                                         <div className='text-center'>
//                                             <div>{contract.co_buyer_name}</div>
//                                             <div>{contract.co_buyer_email}</div>
//                                             <div>{contract.co_buyer_phone}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {contract.txn_coordinator_name && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Transaction Coordinator-Buyer </div>
//                                         <div className='text-center'>
//                                             <div>{contract.txn_coordinator_name}</div>
//                                             <div>{contract.txn_coordinator_email}</div>
//                                             <div>{contract.txn_coordinator_phone}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {contract.seller_name && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Seller</div>
//                                         <div className='text-center'>
//                                             <div>{contract.seller_name}</div>
//                                             <div>{contract.seller_email}</div>
//                                             <div>{contract.seller_phone}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {contract.co_seller_name && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Co-Seller</div>
//                                         <div className='text-center'>
//                                             <div>{contract.co_seller_name}</div>
//                                             <div>{contract.co_seller_email}</div>
//                                             <div>{contract.co_seller_phone}</div>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {contract.loan_officer && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Loan Officer</div>
//                                         <div className='text-center'>
//                                             <div >{contract.loan_officer}</div>
//                                             <div >{contract.loan_officer_phone}</div>
//                                             <div >{contract.loan_officer_email}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {contract.title_company && (
//                                     <div>
//                                         <div className='text-lg text-center font-semibold mb-2'>Title Company</div>
//                                         <div className='text-center'>
//                                             <div >{contract.title_company}</div>
//                                             <div >{contract.title_company_phone}</div>
//                                             <div >{contract.title_company_email}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className="mx-auto bg-white px-6 py-8">
//                             <div className='text-xl text-center font-semibold mb-6'>Workflow</div>
//                             <div>
//                                 {contract.steps.map((step, index) => {
//                                     return (
//                                         <div key={index} className='text-center flex flex-col md:grid md:gap-2 md:grid-cols-7 border-b md:text-left'>
//                                             <div className='col-span-1 m-2 font-bold'>Step {index + 1}</div>
//                                             <div className='col-span-2 m-2'>{step.title}</div>
//                                             <div className='col-span-1 m-2'>{format(parseISO(step.due_date), 'MM/dd/yyyy')}</div>
//                                             <div className='col-span-1 m-2'>{step.status}</div>
//                                             <div className='col-span-2 m-2'>{step.comments}</div>
//                                         </div>
//                                     )
//                                 })}
//                             </div>
//                         </div>

//                         <button className='w-[150px] h-[36px] bg-gray-500 hover:bg-gray-600 text-white rounded-lg text-center text-sm'>
//                             <Link to={"/"}>Dashboard</Link>
//                         </button>

//                     </div>
//                 </div>
//             )}
//         </div>
//     )

// }

// export default ContractDetails

import React, { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { format, parseISO } from 'date-fns';

import { getContract } from "../../features/contractSlice"
import { canAddContractRoles } from '../../utils/Constants';
import { formatAddress, determineAccess } from '../../utils/Helper';

import Spinner from "../Layout/Spinner"
import NotAuthorized from '../Others/NotAuthorized';

const ContractDetails = () => {
    const { id } = useParams()
    const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
    const { contract, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

    const dispatch = useDispatch()

    useEffect(() => {
        const contract_id = id
        dispatch(getContract({ contract_id, idToken }))
    }, [dispatch, id, idToken])

    if (loading) return <Spinner />

    if (!contract || Object.keys(contract).length === 0) {
        return <Spinner />
    }

    const access = determineAccess(role, email, agentEmail, contract)
    if (!access) return <NotAuthorized />

    // Helper function to determine status badge color
    const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
            case 'completed':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'in progress':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'overdue':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen pb-12">
            {Object.keys(contract).length > 0 && (
                <div className="max-w-6xl mx-auto px-4 py-8">
                    <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
                        <Link
                            to="/dashboard"
                            className="inline-flex items-center text-gray-600 hover:text-gray-900"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                            </svg>
                            Back to Dashboard
                        </Link>

                        {canAddContractRoles.includes(role) && (
                            <div className="flex flex-wrap gap-3">
                                <Link
                                    to={`/edit-contract-steps/${contract.contract_id}`}
                                    className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                    </svg>
                                    Edit Workflow
                                </Link>
                                <Link
                                    to={`/edit-contract-info/${contract.contract_id}`}
                                    className="inline-flex items-center px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white text-sm font-medium rounded-lg transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                    Edit Details
                                </Link>
                                <Link
                                    to={`/archive-contract/${contract.contract_id}`}
                                    className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                    Delete Contract
                                </Link>
                            </div>
                        )}
                    </div>

                    <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-8">
                        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                            <h1 className="text-xl font-bold text-white">Contract Details</h1>
                        </div>

                        <div className="p-6">
                            <div className="mb-8 text-center">
                                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                                    {formatAddress(contract.address, contract.apartment, contract.city, contract.state, contract.zipcode)}
                                </h2>

                                <div className="flex flex-wrap justify-center items-center gap-6 mt-4">
                                    <div className="flex items-center">
                                        <div className="text-gray-500 mr-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <span className="text-gray-700">
                                            Acceptance: <span className="font-medium">{format(parseISO(contract.contract_acceptance_date), 'MMM dd, yyyy')}</span>
                                        </span>
                                    </div>

                                    <div className="flex items-center">
                                        <div className="text-gray-500 mr-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <span className="text-gray-700">
                                            Closing: <span className="font-medium">{format(parseISO(contract.closing_date), 'MMM dd, yyyy')}</span>
                                        </span>
                                    </div>

                                    <div className="flex items-center">
                                        <div className="text-gray-500 mr-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <span className="text-gray-700">
                                            Status: <span className={`font-medium px-2 py-1 rounded-full text-xs ${getStatusColor(contract.contract_status)}`}>{contract.contract_status}</span>
                                        </span>
                                    </div>

                                    {contract.sale_price && (
                                        <div className="flex items-center">
                                            <div className="text-gray-500 mr-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div>
                                            <span className="text-gray-700">
                                                Sales Price: <span className="font-medium">${new Intl.NumberFormat('en-US').format(contract.sale_price)}</span>
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {contract.agent_name && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            Agent
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.agent_name}</p>
                                            <p className="text-gray-600 text-sm">{contract.agent_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.agent_phone}</p>
                                        </div>
                                    </div>
                                )}

                                {contract.buyer_name && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            Buyer
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.buyer_name}</p>
                                            <p className="text-gray-600 text-sm">{contract.buyer_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.buyer_phone}</p>
                                        </div>
                                    </div>
                                )}

                                {contract.co_buyer_name && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                            </svg>
                                            Co-Buyer
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.co_buyer_name}</p>
                                            <p className="text-gray-600 text-sm">{contract.co_buyer_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.co_buyer_phone}</p>
                                        </div>
                                    </div>
                                )}

                                {contract.txn_coordinator_name && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                            </svg>
                                            Transaction Coordinator
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.txn_coordinator_name}</p>
                                            <p className="text-gray-600 text-sm">{contract.txn_coordinator_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.txn_coordinator_phone}</p>
                                        </div>
                                    </div>
                                )}

                                {contract.seller_name && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            Seller
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.seller_name}</p>
                                            <p className="text-gray-600 text-sm">{contract.seller_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.seller_phone}</p>
                                        </div>
                                    </div>
                                )}

                                {contract.co_seller_name && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                            </svg>
                                            Co-Seller
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.co_seller_name}</p>
                                            <p className="text-gray-600 text-sm">{contract.co_seller_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.co_seller_phone}</p>
                                        </div>
                                    </div>
                                )}

                                {contract.loan_officer && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                                            </svg>
                                            Loan Officer
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.loan_officer}</p>
                                            <p className="text-gray-600 text-sm">{contract.loan_officer_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.loan_officer_phone}</p>
                                        </div>
                                    </div>
                                )}

                                {contract.title_company && (
                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                        <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                            </svg>
                                            Title Company
                                        </h3>
                                        <div className="space-y-1">
                                            <p className="text-gray-800 font-medium">{contract.title_company}</p>
                                            <p className="text-gray-600 text-sm">{contract.title_company_email}</p>
                                            <p className="text-gray-600 text-sm">{contract.title_company_phone}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4 flex justify-between items-center">
                            <h2 className="text-xl font-bold text-white">Workflow Timeline</h2>
                            <span className="bg-white bg-opacity-20 text-white text-xs font-medium px-2.5 py-0.5 rounded-full">
                                {contract.steps.length} Steps
                            </span>
                        </div>

                        <div className="p-6">
                            {/* Desktop Table View */}
                            <div className="hidden md:block overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Step</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Task</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Due Date</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {contract.steps.map((step, index) => (
                                            <tr key={index} className="hover:bg-gray-50">
                                                <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
                                                        {index + 1}
                                                    </div>
                                                </td>
                                                <td className="px-4 py-4 text-sm text-gray-900">{step.title}</td>
                                                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-700">
                                                    {format(parseISO(step.due_date), 'MMM dd, yyyy')}
                                                </td>
                                                <td className="px-4 py-4 whitespace-nowrap">
                                                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(step.status)}`}>
                                                        {step.status}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-4 text-sm text-gray-700">{step.comments || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Mobile Card View */}
                            <div className="md:hidden space-y-4 mt-4">
                                {contract.steps.map((step, index) => (
                                    <div key={index} className="bg-gray-50 rounded-lg border border-gray-200 p-4">
                                        <div className="flex items-center justify-between mb-3">
                                            <div className="flex items-center">
                                                <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mr-3">
                                                    {index + 1}
                                                </div>
                                                <span className="font-medium text-gray-900 text-sm">Step {index + 1}</span>
                                            </div>
                                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(step.status)} flex-shrink-0`}>
                                                {step.status}
                                            </span>
                                        </div>

                                        <div className="mb-3">
                                            <h4 className="font-medium text-gray-900 text-sm leading-tight">{step.title}</h4>
                                        </div>

                                        <div className="grid grid-cols-1 gap-2 text-sm">
                                            <div>
                                                <span className="text-gray-500 text-xs">Due Date:</span>
                                                <div className="font-medium text-gray-700">
                                                    {format(parseISO(step.due_date), 'MMM dd, yyyy')}
                                                </div>
                                            </div>
                                            {step.comments && (
                                                <div>
                                                    <span className="text-gray-500 text-xs">Comments:</span>
                                                    <div className="text-gray-700 text-sm">
                                                        {step.comments}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            )}
        </div>
    )
}

export default ContractDetails
